import { getDecodedEvent, readContract, writeContractAndWait } from "../viem";
import config from "../../config/config";
import { parseNewCarNickEvent } from "../game";

import MafiaCarNickAbi from "../../abis/MafiaCarNick.json";

export interface NickCarResult {
  transactionHash: string;
  blockNumber: number;
  criminal: string;
  crimeType: number;
  isSuccess: boolean;
  isJailed: boolean;
  xpPoint: number;
  nextNickTime: number;
  inventoryItemId: number;
  cityId: number;
  carType: number;
  damagePercent: number;
  timestamp: number;
  successNonce: number;
}

export const nickCar = async (
  crimeType: number,
  account: string,
  signMsg: string,
  signature: string
): Promise<NickCarResult> => {
  try {
    const tx = await writeContractAndWait({
      address: config.carNickAddress,
      abi: MafiaCarNickAbi,
      functionName: "nickCar",
      args: [crimeType, JSON.stringify(signMsg), signature],
      account,
      gasMultiplier: 5,
    });

    let parsed = {
      criminal: account,
      crimeType: 0,
      isSuccess: false,
      isJailed: false,
      xpPoint: 0,
      nextNickTime: 0,
      inventoryItemId: 0,
      cityId: 0,
      carType: 0,
      damagePercent: 0,
      timestamp: 0,
      successNonce: 0,
    };

    const event = getDecodedEvent(tx, MafiaCarNickAbi, "NewCarNick");
    if (event) {
      parsed = parseNewCarNickEvent(event);
    }

    return {
      transactionHash: tx.transactionHash,
      blockNumber: Number(tx.blockNumber),
      ...parsed,
    };
  } catch (error) {
    console.error("Error nicking the car:", error);
    throw error;
  }
};

export const getNextNickTime = async (account: string) => {
  const nextNickTime = await readContract<string>({
    address: config.carNickAddress,
    abi: MafiaCarNickAbi,
    functionName: "nextNickTime",
    args: [account],
    account,
  });
  return Number(nextNickTime);
};
